<div [ngClass]="getClassList()" [ngStyle]="{'color':color}">{{name}}</div>